exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.Zone-com{line-height:1;position:relative}.Zone-com .emptyholder{width:100%;height:12.8vw;font-size:3.73333vw;display:flex;align-items:center;justify-content:center;color:#999}\n", ""]);

// exports
